import React from "react";
import tw from "twin.macro";
//import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/logo.svg";
import { Link as RouterLink } from "react-router-dom";


const Container = tw(ContainerBase)`bg-primary-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw(RouterLink)`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

//const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} />
            <LogoText>CozyRock.kz</LogoText>
          </LogoContainer>
          <LinksContainer>
            <Link to="/">Главная</Link>
            <Link to="/contact">Контакты/Карта</Link>
            <Link to="/schedule">Расписание</Link>
            <Link to="/prices">Цены</Link>
            <Link to="/webcam">Камеры</Link>
          </LinksContainer>
        </Row>
      </Content>
    </Container>
  );
};
